export enum ReannotateDataReason {
  DIFFERENT_LOCATION = 'DIFFERENT_LOCATION',
  DIFFERENT_TRIGGER_LINE = 'DIFFERENT_TRIGGER_LINE',
  PUT_IN_MPI = 'PUT_IN_MPI',
  TRIGGER_LINE_CHANGE_STRAIGHT_PARABOLIC = 'TRIGGER_LINE_CHANGE_STRAIGHT_PARABOLIC',
  INCORRECTLY_ANNOTATED = 'INCORRECTLY_ANNOTATED',
}
